import { common as enCommon } from './en/common';
import { common as nlCommon } from './nl/common';
import { common as frCommon } from './fr/common';

export const resources = {
  en: {
    common: enCommon
  },
  nl: {
    common: nlCommon
  },
  fr: {
    common: frCommon
  }
};
